import React from "react";
import { iconProps } from "../../Helper";

export const AppsIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g mask="url(#mask0_8807_5800)">
        <path
          className={className}
          d="M12 13.6923L1.50977 8.09625L12 2.5L22.5 8.09625L12 13.6923ZM12 17.596L2.08477 12.3155L3.65577 11.4537L12 15.8885L20.3538 11.4537L21.925 12.3155L12 17.596ZM12 21.5L2.08477 16.2193L3.65577 15.3577L12 19.7922L20.3538 15.3577L21.925 16.2193L12 21.5ZM12 11.9848L19.373 8.09625L12 4.20775L4.63652 8.09625L12 11.9848Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
